import { Star, Clock, FileCheck, MapPin } from "lucide-react";
import { COMPANY } from "@/data/content";

const ITEMS = [
  {
    icon: Star,
    value: `${COMPANY.rating}/5`,
    label: `${COMPANY.reviewsCount} avis Google`,
    gold: true,
  },
  { icon: Clock, value: COMPANY.responseTime, label: "Temps d'intervention" },
  { icon: FileCheck, value: "Gratuit", label: "Devis avant travaux" },
  { icon: MapPin, value: "6 villes", label: "Zone d'intervention" },
];

// Horizontal trust bar with Google rating
export default function TrustBanner() {
  return (
    <section
      data-testid="trust-banner"
      className="relative z-10 bg-white border-b border-brand-line"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 divide-x divide-brand-line">
        {ITEMS.map((it, i) => {
          const Icon = it.icon;
          return (
            <div
              key={i}
              className="px-6 lg:px-10 py-8 md:py-10 flex items-center gap-4"
            >
              <span
                className={
                  "grid place-items-center w-12 h-12 rounded-xl shrink-0 " +
                  (it.gold
                    ? "bg-brand-gold/15 text-brand-golddark"
                    : "bg-brand-navy/5 text-brand-navy")
                }
              >
                <Icon className={"w-6 h-6 " + (it.gold ? "fill-current" : "")} />
              </span>
              <div className="leading-tight">
                <div className="font-display font-semibold text-2xl md:text-3xl tracking-tight text-brand-navy">
                  {it.value}
                </div>
                <div className="text-[11px] md:text-xs uppercase tracking-[0.12em] text-slate-500 font-medium">
                  {it.label}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
